import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SliderVariantProps, sliderVariants } from './slider.variants';

@Component({
  selector: 'lib-slider',
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'classes()',
    '[style.--slider-progress.%]': 'progressPercent()',
  },
})
export class SliderComponent {
  readonly min = input(0);
  readonly max = input(100);
  readonly step = input(1);
  readonly value = input(0);
  readonly disabled = input(false);
  readonly variant = input<SliderVariantProps['variant']>('primary');
  readonly size = input<SliderVariantProps['size']>('md');
  readonly class = input('');
  readonly ariaLabel = input<string | null>(null);

  readonly changed = output<number>();

  protected readonly classes = computed(() =>
    [
      sliderVariants({
        variant: this.variant(),
        size: this.size(),
      }),
      this.class(),
    ]
      .filter(Boolean)
      .join(' ')
  );

  protected readonly progressPercent = computed(() => {
    const min = this.min();
    const max = this.max();

    if (max <= min) {
      return 0;
    }

    return ((this.value() - min) / (max - min)) * 100;
  });

  protected onInput(event: Event): void {
    const nextValue = Number((event.target as HTMLInputElement).value);

    if (Number.isNaN(nextValue)) {
      return;
    }

    this.changed.emit(nextValue);
  }
}
